module.exports = "/src/views/player/help/images/inkas.jpg";